<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { authState, authMethods } from './stores/auth.ts';

const router = useRouter();

onMounted(() => {
  // Refresh authentication state when the auth component is mounted
  authMethods.refresh();
});

function goToLogin() {
  router.push('/login');
}

async function logout() {
  try {
    const baseUrl = import.meta.env.VITE_API_BASE_URL;
    await fetch(`${baseUrl}/logout`, {
      method: 'POST',
      body: JSON.stringify({}),
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies so server can clear/expire them
    });
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    // Always clear local auth state even if the request fails
    authMethods.logout();
    // Redirect to home page after logout
    router.push('/login');
  }
}
</script>

<template>
  <div v-if="!authState.isAuthenticated">
    <button @click="goToLogin" class="inline-flex justify-center rounded-md border border-gray-700 shadow-sm px-4 py-2 bg-gray-800 text-sm font-medium text-white hover:bg-gray-700 focus:outline-none mr-2">
      Login
    </button>
  </div>
  <div v-else class="flex items-center gap-2">
    <span class="text-sm text-white">{{ authState.email }}</span>
    <button @click="logout" class="inline-flex justify-center rounded-md border border-gray-700 shadow-sm px-3 py-1 bg-gray-800 text-xs font-medium text-white hover:bg-gray-700 focus:outline-none">
      Logout
    </button>
  </div>
</template>